<template>
  <main id="line-success">
    <article class="article-success">
      <header class="header-success">
        <h1>ใกล้สำเร็จแล้ว อีกแค่ 1 ขั้นตอน!</h1>
        <p>ตรวจสอบแผนการลงทุนของคุณได้ที่แอป FINNOMENA แล้วเปิดบัญชีเพื่อลงทุนได้ทันที ฟรี ! ไม่มีค่าใช้จ่าย</p>
      </header>

      <section class="instruction-list" v-lazy-container="{ selector: 'img' }">
        <div class="instruction">
          <div class="oval">1</div>
          <div class="instruction-text">
            ดาวน์โหลดแอปพลิเคชัน FINNOMENA ผ่านทาง
            App Store หรือ Google Play Store
          </div>
          <div class="instruction-img">
            <img
              alt="ios"
              class="small"
              v-lazy="`${publicPath}/instruction-1-1.png`"
              :data-srcset="`${publicPath}/instruction-1-1@3x.png`"
            />
            <img
              alt="andriod"
              class="small"
              v-lazy="`${publicPath}/instruction-1-2.png`"
              :data-srcset="`${publicPath}/instruction-1-2@3x.png`"
            />
          </div>
        </div>
        <div class="instruction">
          <div class="oval">2</div>
          <div class="instruction-text">
            เริ่มต้นใช้งานแอป FINNOMENA เลือกแท็บ PORT
            ด้านล่างหน้าจอ และกดลงชื่อเข้าใช้
          </div>
          <div class="instruction-img">
            <img
              alt="login/register"
              v-lazy="`${publicPath}/instruction-2.png`"
              :data-srcset="`${publicPath}/instruction-2@3x.png`"
            />
          </div>
        </div>
        <div class="instruction">
          <div class="oval">3</div>
          <div class="instruction-text">
            กดปุ่มลงชื่อเข้าใช้ด้วย LINE และกรอกข้อมูลเพื่อ
            เข้าใช้งาน
          </div>
          <div class="instruction-img">
            <img
              alt="line login"
              v-lazy="`${publicPath}/instruction-3.png`"
              :data-srcset="`${publicPath}/instruction-3@3x.png`"
            />
          </div>
        </div>
        <div class="instruction">
          <div class="oval">4</div>
          <div class="instruction-text">
            ในแท็บ PORT กดปุ่มเปิดบัญชีลงทุนกับ FINNOMENA
            เพื่อเริ่มกระบวนการเปิดบัญชี
          </div>
          <div class="instruction-img">
            <img
              alt="open account"
              v-lazy="`${publicPath}/instruction-4.png`"
              :data-srcset="`${publicPath}/instruction-4@3x.png`"
            />
          </div>
        </div>
      </section>

      <section id="cta-download">
        <div class="cta-footer">
          <a
            href="javascript:;"
            data-action="click_download_app"
            @click="download()"
            class="cta-btn"
          >ดาวน์โหลด/ตรวจสอบแผนการลงทุน</a>
        </div>
      </section>
    </article>
  </main>
</template>

<script>
import qs from "qs-lite";
import { sendAnalytic } from "../../utils/analytic";

export default {
  data() {
    return {
      publicPath: process.env.VUE_APP_SCONTENT_URL + "/line-liff/introduction",
      objQuery: {}
    };
  },
  props: { userID: String, env: Object, finnakies: String },
  metaInfo: {
    title: "FINNOMENA PORT"
  },
  async created() {},
  async mounted() {
    sendAnalytic({
      luid: this.userID,
      un: this.finnakies,
      de: "line",
      cu: "download_app",
      ac: "open",
      ec: "create_flow",
      et: "on_load"
    });

    let quertStr = qs.stringify(this.$route.query);
    let urlString = quertStr.replace(/&amp%3B/g, "&");
    this.objQuery = qs.parse(urlString);
  },
  methods: {
    async download() {
      sendAnalytic({
        luid: this.userID,
        un: this.finnakies,
        de: "line",
        cu: "download_app",
        ac: "click_download_app",
        ec: "create_flow",
        et: "on_click"
      });

      location.href = "https://finnomena.app.link/line-download-app";
    }
  }
};
</script>
<style lang="scss" scoped>
.header-finno {
  display: none;
}
.footer {
  display: none;
}

#line-success {
  .article-success {
    text-align: center;

    .header-success {
      padding: 36px 18px 0px 18px;
      h1 {
        @extend %font-size-l;
        margin-bottom: 4px;
      }
      p {
        color: $color-secondary;
      }
    }

    .instruction-list {
      margin: 36px 18px 64px 18px;

      .instruction {
        vertical-align: top;
        position: relative;
        .oval {
          width: 16px;
          height: 16px;
          background-color: $color-primary-finno;
          font-size: 12px;
          font-weight: bold;
          border-radius: 50%;
          display: inline-block;
          line-height: 18px;
          margin-right: 7px;
          top: 6px;
          position: absolute;
        }

        .instruction-text {
          min-width: 80%;
          text-align: left;
          display: inline-block;
          margin-left: 30px;
        }

        .instruction-img {
          margin-top: 18px;
          margin-bottom: 56px;
          img {
            max-width: 280px;
          }
          .small {
            display: inline;
            max-width: 165px;
          }
        }
      }
    }

    #cta-download {
      position: fixed;
      bottom: 0;
      width: 100%;
      left: 0;
      text-align: center;
      .cta-footer {
        width: 100%;
        .cta-btn {
          text-decoration: none;
          @extend %btn-primary;
          font-style: normal;
          font-stretch: normal;
          padding: 12.5px 0;
          width: -webkit-fill-available;
        }
      }
    }
  }
}
</style>